import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import * as React from 'react';
import LayersContext from './LayersContext';
var style = {
  // isolation: 'isolate',
  // Emulate `isolation` for IE, Edge
  // `opacity` creates a new stacking context
  // See https://caniuse.com/#feat=mdn-css_properties_isolation
  opacity: 0.9999999
};

/**
 * Overlays: Tooltip, Popover, DropDown, Dialog, Drawer
 * Modals: Dialog, Drawer
 * Messages: Notification
 *
 * Application stacks management.
 * We split the application in several hosts, to be able to render portaled
 * elements in isolation, and efficiently tackle stacking contexts.
 * Prevent `z-index` or `overflow` issues arrising with traditonal "in flow" management.
 * Messages (like notifications) get their own host to:
 * - Make sure they are always displayed on top of any modal element
 * - Make it easier to target and isolate them for hidden/inert content
 *   management (screenreaders). I.e.: an open Dialog trigerring a notification,
 *   you want everything **but** the modal and the notification to be hidden.
 * - They require a wrapping parent with aria properties to be always rendered
 *   in the DOM, which would make it more complex to manage dynamicaly.
 *
 * - root: default host target, all "in flow" elements
 * - overlays: default portaled and modal elements host
 * - messages: only notifications for now
 */

function Layers(props) {
  var rootRef = React.useRef(null);
  var overlaysRef = React.useRef(null);
  var messagesRef = React.useRef(null);
  var _React$useState = React.useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    state = _React$useState2[0],
    setState = _React$useState2[1];
  React.useEffect(function () {
    setState({
      root: rootRef.current,
      overlays: overlaysRef.current,
      messages: messagesRef.current
    });
  }, []);
  return /*#__PURE__*/React.createElement(LayersContext.Provider, {
    value: state
  }, /*#__PURE__*/React.createElement("div", {
    ref: rootRef,
    style: style
  }, props.children), /*#__PURE__*/React.createElement("div", {
    ref: overlaysRef,
    style: style
  }), /*#__PURE__*/React.createElement("div", {
    ref: messagesRef,
    style: style
  }));
}
export default Layers;